// import React from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import logo from './assets/img/logo.png';
// import icon1 from './assets/img/icon-1.png';
// import icon2 from './assets/img/icon-2.png';
// import icon3 from './assets/img/icon-3.png';
// import icon4 from './assets/img/icon-4.png';
// import icon5 from './assets/img/icon-5.png';
// import icon6 from './assets/img/icon-6.png';
// import logout from './assets/img/logout.png'

// const Sidebar = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const isActive = (path) => location.pathname === path;

//   function userLogout() {
//     localStorage.removeItem('token');
//     navigate('/');
//   }


//   return (
//     <div className="col-md-2 sidebar">
//       <img src={logo} className="img-fluid logo" alt="Logo" />
//       <div className="navigation">
//         <div className={`nav-list ${isActive('/dashboard') ? 'active' : ''}`}>
//           <a href="/dashboard"><img src={icon1} className="img-fluid" alt="Dashboard" /> Dashboard</a>
//         </div>
//         <div className="nav-list">
//           {/* Open in a new tab */}
//           <a
//             href="/imei-finder"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <img src={icon2} className="img-fluid" alt="IMEI Finder" />Live IMEI Finder
//           </a>
//         </div>
//         <div className={`nav-list ${isActive('/customers') ? 'active' : ''}`}>
//           <a href="/imei-script"><img src={icon6} className="img-fluid" alt="Customers" />QC IMEI Finder</a>
//         </div>
//         <div className={`nav-list ${isActive('/device-reports') ? 'active' : ''}`}>
//           <a href="/device-reports"><img src={icon3} className="img-fluid" alt="Reports" />Inventory Reports</a>
//         </div>

//         <div className={`nav-list ${isActive('/all-reports') ? 'active' : ''}`}>
//           <a href="/all-reports"><img src={icon4} className="img-fluid" alt="Protection Plan" />All Transactions</a>
//         </div>
//         <div className={`nav-list ${isActive('/transactions') ? 'active' : ''}`}>
//           <a href="/grade-compare"><img src={icon5} className="img-fluid" alt="Transactions" />Grading Insights</a>
//         </div>
//         {/* <div className={`nav-list ${isActive('/marketplace') ? 'active marketplace' : ''}`}>
//           <a href="/marketplace"><img style={{background:'whtie', color:'red'}} src='./crm.png' className="img-fluid" alt="Customers" />Marketplace</a>
//         </div> */}
//       </div>

      
//       <div className="logout-section">
//         <button
//           className="btn w-100 mt-3 d-flex flex-column align-items-center"
//           onClick={userLogout}
//           style={{
//             backgroundColor: '#CE2E28',
//             border: 'none',
//             color: 'white',
//             padding: '10px',
//            }}
//         >
//           <img
//             src={logout}
//             alt="Logout"
//           />
//           <span style={{ fontSize: '16px' }}>Logout</span>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;


import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from './assets/img/logo.png';
import icon1 from './assets/img/icon-1.png';
import icon2 from './assets/img/icon-2.png';
import icon3 from './assets/img/icon-3.png';
import icon4 from './assets/img/icon-4.png';
import icon5 from './assets/img/icon-5.png';
import icon6 from './assets/img/icon-6.png';
import logout from './assets/img/logout.png';
import { MenuOutlined } from '@ant-design/icons';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const isActive = (path) => location.pathname === path;
 
  function userLogout() {
    localStorage.removeItem('token');
    navigate('/');
  }

  return (
    <>
      {/* Hamburger Icon - Visible only on small screens */}
<div className="sidebar-container" style={{padding: '0px',}}>
  
  {/* Hamburger Icon - Visible only on small screens */}
      <MenuOutlined
        className="sidebar-toggle"
        onClick={() => setIsOpen(!isOpen)}
      />
      <div className={`col-md-2 sidebar ${isOpen ? 'open' : ''}`}>
        <img src={logo} className="img-fluid logo" alt="Logo" />
        <div className="navigation">
          <div className={`nav-list ${isActive('/dashboard') ? 'active' : ''}`}>
            <a href="/dashboard"><img src={icon1} className="img-fluid" alt="Dashboard" /> Dashboard</a>
          </div>
          {/* <div className="nav-list">
            <a href="/imei-finder" target="_blank" rel="noopener noreferrer">
            <a href="/live-transactions" target="_blank" rel="noopener noreferrer">
              <img src={icon2} className="img-fluid" alt="IMEI Finder" />Live Transactions
            </a>
          </div> */}
          <div className={`nav-list ${isActive('/live-transactions') ? 'active' : ''}`}>
            <a href="/live-transactions"><img src={icon6} className="img-fluid" alt="Customers" />Live Transactions</a>
          </div>
          <div className={`nav-list ${isActive('/device-reports') ? 'active' : ''}`}>
            <a href="/device-reports"><img src={icon3} className="img-fluid" alt="Reports" />Inventory Reports</a>
          </div>
          <div className={`nav-list ${isActive('/all-reports') ? 'active' : ''}`}>
            <a href="/all-reports"><img src={icon4} className="img-fluid" alt="Protection Plan" />Warehouse Transactions</a>
          </div>
          <div className={`nav-list ${isActive('/grade-compare') ? 'active' : ''}`}>
            <a href="/grade-compare"><img src={icon5} className="img-fluid" alt="Transactions" />Grading Insights</a>
          </div>
          <div className={`nav-list ${isActive('/promocode-management') ? 'active' : ''}`}>
            <a href="/promocode-management"><img src={icon2} className="img-fluid" alt="Transactions" />Discounts</a>
          </div>
        </div>

        <div className="logout-section">
          <button
            className="btn w-100 mt-3 d-flex flex-column align-items-center"
            onClick={userLogout}
            style={{
              backgroundColor: '#CE2E28',
              border: 'none',
              color: 'white',
              padding: '10px',
            }}
          >
            <img src={logout} alt="Logout" />
            <span style={{ fontSize: '16px' }}>Logout</span>
          </button>
        </div>
      </div>
      </div>
    </>
  );
};

export default Sidebar;















